import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    background: theme.palette.grey[100],
  },
}));
